import {on} from '../helpers/utils';
import cssClasses from '../helpers/cssClasses';

// DOM selectors.
const selectors = {
  container: '[js-accordion-readmore="container"]',
  content: '[js-accordion-readmore="content"]',
  trigger: '[js-accordion-readmore="trigger"]',
};

export default () => {
  // Node selectors.
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    containerExpand: document.querySelector(selectors.content),
    trigger: document.querySelector(selectors.trigger),
  };

  // Set listeners.
  function setListeners() {
    if (!nodeSelectors.trigger) {
      return;
    }
    on('click', nodeSelectors.trigger, (event) => handleToggle(event));

    // window.setTimeout(() => {
    //   setHeight();
    // }, 800);
  }

  /**
   * Sets height of section on load
   */
  function setHeight() {
    const accordion =
      nodeSelectors.containerExpand.querySelector('.accordion_section');

    const ingredientsGrid = nodeSelectors.containerExpand.querySelector(
      '[js-ingredients="content"]',
    );

    if (accordion.textContent.trim()) {
      nodeSelectors.container.style.height = `${accordion.clientHeight}px`;
    } else if (ingredientsGrid) {
      nodeSelectors.container.style.height = `${ingredientsGrid.clientHeight}px`;
    }
  }

  /**
   * Open and close toggle
   */
  function handleToggle(event) {
    event.preventDefault();

    if (nodeSelectors.trigger.classList.contains(cssClasses.active)) {
      removeActiveState();
      removeHeight();
    } else {
      const anchor = document.querySelector('#ingredients');
      anchor.scrollIntoView({block: 'start'});
      addActiveState();
      addHeight();
    }
  }

  function addActiveState() {
    nodeSelectors.container.classList.add(cssClasses.active);
    nodeSelectors.trigger.classList.add(cssClasses.active);
  }

  function addHeight() {
    const {clientHeight} = document.querySelector(selectors.content);
    nodeSelectors.container.setAttribute(
      'style',
      `height: ${clientHeight + 25}px`,
    );
  }

  function jumpToTop() {
    document.getElementById('ingredients').scrollIntoView({block: 'end'});
  }

  function removeActiveState() {
    nodeSelectors.container.classList.remove(cssClasses.active);
    nodeSelectors.trigger.classList.remove(cssClasses.active);

    window.setTimeout(() => {
      jumpToTop();
    }, 500);
  }

  function removeHeight() {
    nodeSelectors.container.setAttribute('style', `height: "inherit"`);
    setHeight();
  }

  function init() {
    setListeners();
  }

  // Public interface.
  return Object.freeze({
    init,
  });
};
